import Home from "./pages/home/home";
import Group from "./pages/group/group";
import Faq from "./pages/faq/faq";

const Homepage = { Home, Group, Faq };

export default Homepage;
